const getValidationErrors = (value, rules) => {
  const errors = [];
  if ((rules == null ? void 0 : rules.pattern) !== void 0) {
    const validationExpression = new RegExp(rules.pattern, "g");
    if (!validationExpression.test(String(value))) {
      errors.push({
        label: "invalidInput"
      });
    }
  }
  return errors;
};

export { getValidationErrors };
